import { Sparkles } from "lucide-react";
import { useCart } from "../contexts/CartContext";

export default function UpsellBanner({ variant = "default" }) {
  const { discountInfo, cartCount } = useCart();

  if (cartCount === 0 || !discountInfo?.next_tier) return null;

  const { items_needed, next_discount } = discountInfo.next_tier;
  const currentDiscount = discountInfo.discount_percent || 0;

  const message = currentDiscount > 0
    ? `You're saving ${currentDiscount}%! Add ${items_needed} more for ${next_discount}% off`
    : `Add ${items_needed} more item${items_needed > 1 ? "s" : ""} to unlock ${next_discount}% off`;

  if (variant === "compact") {
    return (
      <div
        className="flex items-center gap-2 px-3 py-2 bg-[#F5F0E6] border border-[#9A7B4F]/15 text-[11px] text-[#9A7B4F]"
        data-testid="upsell-banner"
      >
        <Sparkles className="w-3.5 h-3.5 flex-shrink-0" strokeWidth={1.5} />
        <span>{message}</span>
      </div>
    );
  }

  return (
    <div
      className="flex items-center gap-2.5 px-4 py-3 bg-gradient-to-r from-[#F5F0E6] to-[#FAF8F0] border border-[#9A7B4F]/20 text-[12px] text-[#9A7B4F]"
      data-testid="upsell-banner"
    >
      <div className="w-7 h-7 bg-[#9A7B4F]/10 flex items-center justify-center flex-shrink-0">
        <Sparkles className="w-4 h-4" strokeWidth={1.5} />
      </div>
      <span className="font-medium">{message}</span>
    </div>
  );
}
